import React from 'react';
import { useAppSelector } from '../../../../../redux/hooks';
import { rootState } from '../../../../../redux/store';
import { ITreeNode } from '../../../../../interface/interfaces';
import { SpacingCustom } from '../../../../layout/Spacing/SpacingCustom';
import MemoizedNode from '../../../Tree/Node';
import { getRandomNodes } from './utils/getRandomNodes';
import { ScrollY } from '../../../../layout/Scroll/ScrollY';

export const ConflictCategoryList = () => {
    const { projectDetailsData } = useAppSelector((state: rootState) => state.projectDetails);

    const conflictNodesTemp = getRandomNodes(projectDetailsData, 12).map((node: ITreeNode, idx: number) => {
        return (
            <SpacingCustom key={idx} marginLeft={-0.5} paddingRight={0.5} paddingTop={0.5}>
                <MemoizedNode
                    useChecker={false}
                    toolTipOn={false}
                    toolTipText={node.ParentNode?.Type}
                    nodeDetail={node}
                    conflictSize={1.6}
                    showIcon={false}
                    textColor={'dark'}
                    color={'accent-green'}
                    borderColor={'accent-green'}
                    transparanetIntensityColor={0.05}
                    transparentIntensityBorder={0.25}
                    func={() => console.log()}
                />
            </SpacingCustom>
        );
    });

    return (
        <ScrollY>
            <SpacingCustom paddingTop={2}>
                <ul className="tree">{conflictNodesTemp}</ul>
            </SpacingCustom>
        </ScrollY>
    );
};
